import { useState } from "react";
import { getCookieConsentValue } from "react-cookie-consent";
import { useKonami } from "react-konami-code";
import { useManualQuery } from "graphql-hooks";

import Modal from "../components/modals";
import Promo2022 from "../parts/offers";

export const GET_ERROR = /* GraphQL */ `
  query getError {
    me {
      id
    }
  }
`;

export default function Home() {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    setIsOpen(false);
  };
  useKonami(() => setIsOpen(true), { code: [66, 69, 86, 89] });

  const [run] = useManualQuery(GET_ERROR);

  return (
    <>
      <Modal title="Debug" isOpen={isOpen} onClose={onClose}>
        <div
          onClick={() => {
            const hasConsent = getCookieConsentValue();
            throw new Error(`ups, ${hasConsent}`);
          }}
        >
          Dom error
        </div>
        <div
          onClick={() => {
            run();
          }}
        >
          GQL error
        </div>
      </Modal>

      <Promo2022 />
    </>
  );
}
